import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericAkitaHTTPService, HttpOptions } from '../../service/generic-akita-http.service';
import { CrowdFlowObserved } from '../../model/crowd-flow-observed';
import { NetworkService } from '../../service/network.service';


@Injectable({
  providedIn: 'root'
})
export class AkitaCrowdFlowObservedHttpService extends GenericAkitaHTTPService<CrowdFlowObserved> {
  constructor(http: HttpClient, networkService: NetworkService) {
    const options: HttpOptions = {
      params: {
        type: 'CrowdFlowObserved',
        options: 'keyValues',
        limit: '50'
      }
    };
    super(http, networkService, '/v2/entities/', 'CrowdFlowObserved', options);
  }
}
